import { call, fork, put, takeEvery } from "typed-redux-saga";
import { getAppServerClient } from "@advosys/component-app-server-client-js";
import { actions as matterLedgerEntriesActions } from "../matter-ledger-entries/matter-ledger-entries-store";
import { actions as dynamicInvoicePageActions } from "../../../../dynamic-invoice-page-store";
import { actions, MainInformationActionTypes } from "./main-information-store";
function* getParties(action) {
    const apiResult = yield* call(getAppServerClient().finance.preparedInvoiceV2.getPreparedInvoiceRecipientsAsync, action.payload.preparedInvoiceId);
    if (apiResult.ok) {
        yield* put(actions.getPartiesSuccess(apiResult.data));
    }
    else {
        yield* put(actions.getPartiesFail(apiResult.error));
    }
}
function* watchGetPartiesRequest() {
    yield* takeEvery(MainInformationActionTypes.GetPartiesRequest, getParties);
}
function* getContacts(action) {
    const apiResult = yield* call(getAppServerClient().identity.identityV2.getContactsAsync, action.payload.entityId);
    if (apiResult.ok) {
        yield* put(actions.getContactsSuccess(apiResult.data));
    }
    else {
        yield* put(actions.getContactsFail(apiResult.error));
    }
}
function* watchGetContactsRequest() {
    yield* takeEvery(MainInformationActionTypes.GetContactsRequest, getContacts);
}
function* updateMatterLedgerEntryRelations(action) {
    const apiResult = yield* call(getAppServerClient().finance.preparedInvoiceV2.updatePreparedInvoiceRelationsAsync, action.payload.preparedInvoiceId, action.payload.entityId);
    if (apiResult.ok) {
        yield* put(actions.updateMatterLedgerEntryRelationsSuccess(apiResult.data));
        yield* put(matterLedgerEntriesActions.getMatterLedgerEntriesRequest(action.payload.preparedInvoiceId));
        yield* put(dynamicInvoicePageActions.updateRecipientAndTotalMatterLedgerEntries(action.payload.preparedInvoiceId, action.payload.entityId, action.payload.entityName, apiResult.data));
    }
    else {
        yield* put(actions.updateMatterLedgerEntryRelationsFail(apiResult.error));
    }
}
function* watchUpdateMatterLedgerEntryRelationsRequest() {
    yield* takeEvery(MainInformationActionTypes.UpdateMatterLedgerEntryRelationsRequest, updateMatterLedgerEntryRelations);
}
export const mainInformationSagaInit = () => [fork(watchGetPartiesRequest), fork(watchGetContactsRequest), fork(watchUpdateMatterLedgerEntryRelationsRequest)];
